/// <reference path="../types/index.d.ts" />

import '../client_forms/tcacontactevent/style.css';
import FormStructure from './tcacontactevent/form_structure';

export default FormStructure;